export default __webpack_public_path__ + "static/media/Guidescreen.17ede602.svg";